export default __webpack_public_path__ + "static/media/crewbb.42a9a5da.svg";